
// 美国项目地址
let urlHead = 'https://laravel.rakumart.us'
export default urlHead